// Measures shared by the app shell (MainLayout, MainNavbar). MainLayout publishes them as CSS
// variables on its content column (--shell-navbar-h, --shell-pad). Views that fill the content
// area use the h-full / flex-1 min-h-0 chain (data-shell-fill), never "100vh - N".

// Height of the top bar, border included
export const SHELL_NAVBAR_HEIGHT = 65;
// Padding of the content area, all four sides
export const SHELL_CONTENT_PADDING = 24;

// --shell-pad of MainContent by viewport: < 640 xs, 640-1023 sm, 1024-1919 lg, >= 1920 wide
export const SHELL_PAD = { xs: 12, sm: 16, lg: 24, wide: 32 };
// Space between the blocks of a fill view (header, toolbar, content: pt-4)
export const SHELL_SECTION_GAP = 16;

// Viewport breakpoints in px, the same as Tailwind (sm md lg xl 2xl) plus 1920. In JS media
// queries use these numbers, e.g. useMediaQuery("(min-width:1280px)"), not
// theme.breakpoints.up("md"): MUI's md is 900 and does not match Tailwind's md (768).
export const BREAKPOINTS = { sm: 640, md: 768, lg: 1024, xl: 1280, xxl: 1536, wide: 1920 };

// Max width of the content: reading and forms, documents with a side rail, wide pages
export const CONTENT_WIDTH = { reading: 880, document: 1200, wide: 1440 };

// Sidebar widths stay defined in utils/consts; re-exported so the shell has one import
export { SIDEBAR_WIDTH, SIDEBAR_WIDTH_COLLAPSED } from "utils/consts";
